<div class="panel panel-cell panel-thead" [class.overflow-y-scroll]="hasScrollbar()">
	<div class="row no-gutters">

		<div class="col short-col"></div>
		<div data-testid="SUBSYS2_PLANLIST_HEADER_PLANID" class="col" [class.active]="activeColumn() === fields.planNumber">
			<sortable-header [name]="fields.planNumber" (sort)="onSort($event)">
				{{labels().PLAN_TABLE_COMPONENT_PLAN_ID}}
			</sortable-header>
		</div>
		<div data-testid="SUBSYS2_PLANLIST_HEADER_DEVICE" class="col"
			[class.active]="activeColumn() === fields.displayDevice">
			<sortable-header [name]="fields.displayDevice" (sort)="onSort($event)">
				{{labels().PLAN_TABLE_COMPONENT_DEVICE}}
			</sortable-header>
		</div>
		<div data-testid="SUBSYS2_PLANLIST_HEADER_STEP" class="col"
			[class.active]="activeColumn() === fields.displayPlanStep">
			<sortable-header [name]="fields.displayPlanStep" (sort)="onSort($event)">
				{{labels().PLAN_TABLE_COMPONENT_PLAN_STEP}}
			</sortable-header>
		</div>
		<div data-testid="SUBSYS2_PLANLIST_HEADER_TYPE" class="col"
			[class.active]="activeColumn() === fields.displayPlanType">
			<sortable-header [name]="fields.displayPlanType" (sort)="onSort($event)">
				{{labels().PLAN_TABLE_COMPONENT_PLAN_TYPE}}
			</sortable-header>
		</div>
		<div data-testid="SUBSYS2_PLANLIST_HEADER_SCENARIO" class="col"
			[class.active]="activeColumn() === fields.displayScenario">
			<sortable-header [name]="fields.displayScenario" (sort)="onSort($event)">
				{{labels().PLAN_TABLE_COMPONENT_PLAN_SCENARIO}}
			</sortable-header>
		</div>
		<div data-testid="SUBSYS2_PLANLIST_HEADER_SIDE" class="col" [class.active]="activeColumn() === fields.displaySide">
			<sortable-header [name]="fields.displaySide" (sort)="onSort($event)">
				{{labels().PLAN_TABLE_COMPONENT_PLAN_SIDE}}
			</sortable-header>
		</div>
		<div data-testid="SUBSYS2_PLANLIST_HEADER_BONE" class="col"
			[class.active]="activeColumn() === fields.displayBoneType">
			<sortable-header [name]="fields.displayBoneType" (sort)="onSort($event)">
				{{labels().PLAN_TABLE_COMPONENT_PLAN_BONE_TYPE}}
			</sortable-header>
		</div>
		@if (isTlhexUser()) {
		<div data-testid="SUBSYS2_PLANLIST_HEADER_FRAMEID" class="col"
			[class.active]="activeColumn() === fields.planFrameId">
			<sortable-header [name]="fields.planFrameId" (sort)="onSort($event)">
				{{labels().PLAN_TABLE_COMPONENT_PLAN_FRAME_ID}}
			</sortable-header>
		</div>
		<div data-testid="SUBSYS2_PLANLIST_HEADER_STATUS" class="col no-link">
			{{labels().PLAN_TABLE_COMPONENT_PLAN_STATUS}}
		</div>
		<div data-testid="SUBSYS2_PLANLIST_HEADER_DAYSLEFT" class="col"
			[class.active]="activeColumn() === fields.planDaysLeft">
			<sortable-header [name]="fields.planDaysLeft" (sort)="onSort($event)">
				{{labels().PLAN_TABLE_COMPONENT_PLAN_DAYS_LEFT}}
			</sortable-header>
		</div>
		}
		<div data-testid="SUBSYS2_PLANLIST_HEADER_UPDATEDATE" class="col"
			[class.active]="activeColumn() === fields.planModifiedDate">
			<sortable-header [name]="fields.planModifiedDate" (sort)="onSort($event)">
				{{labels().PLAN_TABLE_COMPONENT_PLAN_MODIFICATION_DATE}}
			</sortable-header>
			<br>
			<span data-testid="SUBSYS2_PLANLIST_HEADER_FORMATDATE_TXT" class="date-format">{{ dateFormat }}</span>
		</div>

	</div>
</div>

<div class="panel-content-list" #scrollContainer>
	@for (plan of items(); track plan.planId) {
	<div class="panel panel-cell panel-tr panel-selectable" [class.selected]="plan.planId === selectedPlan()?.planId"
		(click)="selectedPlan.set(plan)" (keypress)="selectedPlan.set(plan)">
		<div class="row no-gutters">

			<div class="col short-col">
				<div class="form-group pb-0">
					<div class="custom-control custom-radio custom-control-inline custom-radio-unlabelled">
						<input type="radio" class="custom-control-input" name="plan" [id]="'radio-'+plan.planId"
							[value]="plan.planId" [ngModel]="selectedPlan()?.planId">
						<label class="custom-control-label" [for]="'radio-'+plan.planId">&nbsp;</label>
					</div>
				</div>
			</div>
			<div data-testid="SUBSYS2_PLANLIST_CELL_PLANID" class="col">
				@if (isEditable(plan)) {
				<span class="a-link" (click)="editPlan(plan.planId!)" (keypress)="editPlan(plan.planId!)">
					{{plan.planNumber}}
				</span>
				} @else {
				{{plan.planNumber}}
				@if(!isPlanVersionValid(plan)) {
				<span data-testid="SUBSYS2_PLANLIST_UPGRADE_ICON" class="upgrade-icon ms-4"
					[ngbTooltip]="labels().PLAN_TABLE_COMPONENT_UPGRADE_TOOLTIP" placement="top" tooltipClass="white-tooltip"
					container="body">
					<i class="material-icons fake-material-icon upgrade"></i>
				</span>
				}
				}
			</div>
			<div data-testid="SUBSYS2_PLANLIST_CELL_DEVICE" class="col">
				{{ (plan.displayDevice || '--') | uppercase }}
			</div>
			<div data-testid="SUBSYS2_PLANLIST_CELL_STEP" class="col">
				{{ plan.displayPlanStep || '--' }}
			</div>
			<div data-testid="SUBSYS2_PLANLIST_CELL_TYPE" class="col">
				{{ plan.displayPlanType }}
			</div>
			<div data-testid="SUBSYS2_PLANLIST_CELL_SCENARIO" class="col">
				{{ plan.displayScenario }}
			</div>
			<div data-testid="SUBSYS2_PLANLIST_CELL_SIDE" class="col">
				{{ plan.displaySide }}
			</div>
			<div data-testid="SUBSYS2_PLANLIST_CELL_BONE" class="col">
				{{ plan.displayBoneType }}
			</div>
			@if (isTlhexUser()) {
			<div data-testid="SUBSYS2_PLANLIST_CELL_FRAMEID" class="col"
				[ngbTooltip]="plan.caseIsLastModified ? (labels().PLAN_TABLE_COMPONENT_FRAME_ID_LAST_INFO_TOOLTIP | replace:plan.frameID:plan.patientNumber) : null"
				placement="top" tooltipClass="white-tooltip" container="body">
				@if (plan.caseIsLastModified) {
				<span data-testid="SUBSYS2_PLANLIST_CELL_LAST_INFO" class="colored-chip frame-info">
					{{ labels().PLAN_TABLE_COMPONENT_FRAME_ID_LAST_INFO }}
				</span>
				}
				{{ plan.frameID ?? '--' }}
			</div>
			<div data-testid="SUBSYS2_PLANLIST_CELL_STATUS" class="col">
				@let planStatus = plan.device === deviceEnum.Tlhex ? (plan.step | planStatus:plan.caseIsRevoked) : null;
				@if (planStatus) {
				<div class="d-flex justify-content-between align-items-center flex-wrap flex-column">
					<button type="button" class="btn colored-chip" [class]="statusClassEnum[planStatus]">
						{{ planStatus | planStatusLabel }}
					</button>
					@if (plan.caseIsPublished) { <img class="published-icon mt-3" alt="published icon" />}
					@else if (plan.caseIsRevoked) { <img class="revoked-icon mt-3" alt="revoked icon" /> }
				</div>
				} @else { -- }
			</div>
			<div data-testid="SUBSYS2_PLANLIST_CELL_DAYSLEFT" class="col">
				{{ plan.caseDaysLeft !== null ? plan.caseDaysLeft : '--' }}
			</div>
			}
			<div data-testid="SUBSYS2_PLANLIST_CELL_UPDATEDATE" class="col">
				{{ plan.caseModifiedDate! | convertDate:false }}
			</div>

		</div>
	</div>
	}
</div>

<plan-action-box [plan]="selectedPlan()" [isTlhexUser]="!!isTlhexUser()" [isDisabled]="isActionBoxDisabled()" />